import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ReOrderCopiedCitationCommand from './reordercopiedcitationcommand';
import ReOrderCopiedCitationEditing from './reordercopiedcitationediting';

export default class ReOrderCopiedCitation extends Plugin {
  static get pluginName() {
    return 'ReOrderCopiedCitation';
  }
  static get requires() {
    return [ReOrderCopiedCitationEditing, ReOrderCopiedCitationCommand];
  }
}